export const roleMap = {
  role_full_admin: 'Full Admin',
  role_reviewer: 'Reviewer',
  role_limited_reviewer: 'Limited Reviewer',
  role_account_admin : 'Barracuda Full Admin',
  role_bcc_msp_partneradmin : 'MSP Full Admin',
  role_bcc_msp_tech : 'MSP Reviewer',
  role_bcc_msp_technodelete : 'MSP Limited Reviewer',
};
